module.exports = {"140822100":"解店镇","140822101":"通化镇","140822102":"汉薛镇","140822103":"荣河镇","140822200":"万泉乡","140822201":"里望乡","140822202":"西村乡","140822203":"南张乡","140822204":"高村乡","140822205":"皇甫乡","140822206":"贾村乡","140822207":"王显乡","140822208":"光华乡","140822209":"裴庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140822.json
// module id = 335
// module chunks = 0